import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { UglImportTaskEntity } from '../../entities/ugl-import-task.entity';
import { UglImportTaskActionTypes } from '../actions/ugl-import-task.actions';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';


export const UGL_IMPORT_TASK_KEY = 'uglImportTask';

export interface UglImportTaskState extends EntityState<UglImportTaskEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<UglImportTaskEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const uglImportTaskReducer = createReducer(
    initialState,
    on(UglImportTaskActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state }/*, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }*/),
    ),
    on(UglImportTaskActionTypes.UpdateOne, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(UglImportTaskActionTypes.CreateSuccess, (state, { Payload }) => adapter.addOne(Payload, state)),
    on(UglImportTaskActionTypes.RemoveOne, (state, { Payload }) => adapter.removeOne(Payload, state)),
    on(UglImportTaskActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllUglImportTask = selectAll;
export const selectUglImportTaskEntities = selectEntities;

export const selectUglImportTaskFetched = (state: UglImportTaskState) => state.fetched;
export const selectUglImportTaskLatestUpdatedAt = (state: UglImportTaskState) => state.latestUpdatedAt;
